/** ========================================================================= *\
 * @prefabs Doggo
 * ========================================================================== */
import * as CONST from 'config';

let jumpCount = 0;
let doubleJumpCount = 0;

class Doggo extends Phaser.Sprite {

  /** Default Options ------------------------------------------------------- */
  static defaultOptions = {
    x: 640,
    y: 420,
    gravity: 2200,
  }

  /** Class Properties ------------------------------------------------------ */
  game = undefined;
  options = Doggo.defaultOptions;
  isJumping = false;
  hasDoubleJumped = false;
  runningAnimation = undefined;
  isGameOver = false;
  invincible = false;
  invicibilityTimer = null;
  powerTimer = null;
  power = false;
  breakPow = false;

  /** @constructor ---------------------------------------------------------- */
  constructor(game, customOptions) {
    // Instatiate parent class
    const options = { ...Doggo.defaultOptions, ...customOptions };
    super(game, options.x, options.y, options.dogtype, 1);
    this.game = game;

    this.scale = new Phaser.Point(0.4, 0.4);
    this.anchor.setTo(0.5, 1);
    this.health = CONST.LIVES;

    // Enable physics
    game.physics.arcade.enable(this);
    this.body.gravity.y = options.gravity;

    // Attach event listeners
    this._attachEventListeners();

    // Play sprite animation
    this.animations.add('run');
    this.runningAnimation = this.animations.play('run', 60, true);

    const shadowGraphics = new Phaser.Graphics(game, 0, 0);
    shadowGraphics.beginFill(0x000000);
    shadowGraphics.drawEllipse(0, 0, this.width / 2.5, 7);
    shadowGraphics.endFill();

    const shadow = new Phaser.Sprite(game, 0, 0, shadowGraphics.generateTexture());
    shadow.anchor.set(0.5, 1);
    shadow.alpha = 0.1;
    this.addChild(shadow);

    // Powerbar indication
    const PowerGraphics = new Phaser.Graphics(game, 0, 0);
    PowerGraphics.beginFill(0x7c0410);
    PowerGraphics.drawRect(0, 100, this.width, 20);
    PowerGraphics.endFill();

    const powerBar = new Phaser.Sprite(game, 0, 0, PowerGraphics.generateTexture());
    powerBar.anchor.set(0.5, 12);
    powerBar.alpha = 0;
    powerBar.name = "powerBar"
    this.addChild(powerBar);

    // Create smoke sprite
    this.smoke = new Phaser.Sprite(game, -70, 0, 'poof', 0);
    this.smoke.animations.add('smoking', [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 0], false);
    this.smoke.anchor.set(0.5, 1);
    this.addChild(this.smoke);

    // Create sound effect
    this.jump = this.game.add.sound('DogJump')
    this.doublejump = this.game.add.sound('DogDoubleJump')
    this.dogHitMusic = this.game.add.sound('DogHit');
    this.dogFlySound = this.game.add.sound("DogFly");
    this.dogSpeedSound = this.game.add.sound("DogSpeed");

    // this.game.onWin.add(() => this._setGameOver());
    this.game.onLose.add(() => this._setGameOver());
  }

  _attachEventListeners() {
    this.spaceKey = this.game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);
    this.spaceKey.onDown.add(this.keyDown, this);
    this.game.input.onDown.add(this.keyDown, this);
  }

  _setGameOver() {
    this.isGameOver = true;
    // window.setTimeout(() => this.isGameOver = true, 500);
  }

  update() {
    const threshold = (this.game.world.width - this.game.width) / this.game.world.width;

    // Reset isJumping and hasDoubleJumped variable
    if (this.isJumping && this.body.velocity.y == 0 && !this.breakPow) {
      this.isJumping = false;
      this.runningAnimation.speed = 60;
      if (this.hasDoubleJumped) {
        this.hasDoubleJumped = false;
      }
    }

    // this.x += 7;
  }

  keyDown(e) {
    console.log('jump')
    // Jump the doggo
    if (this.body.velocity.y == 0) {
      this.isJumping = true;
      this.body.velocity.y = -CONST.JUMP_VELOCITY;
      this.runningAnimation.speed = 120;
      this.jump.play();
      jumpCount += 1;
    } else {
      if (!this.hasDoubleJumped || CONST.FLAPPY_BIRD_MODE) {
        this.body.velocity.y = -CONST.JUMP_VELOCITY * 0.9;
        this.hasDoubleJumped = true;
        this.smoke.animations.play('smoking', 24, false);
        this.doublejump.play();
        doubleJumpCount += 1;
      }
    }
  }

  damage(amount) {
    super.damage(amount);

    // Set doggo invincibile for 2 seconds
    if (this.invicibilityTimer === null && !this.breakPow) {
      this.invincible = true;

      // Flash doggo to indicate invincibility
      const tween = this.game.add.tween(this).to({ alpha: 0 }, 100, Phaser.Easing.Linear.None, true, 0, -1, true);

      // Reset after 2 seconds
      this.invicibilityTimer = setTimeout(() => {
        this.invincible = false;
        this.invicibilityTimer = null;
        this.alpha = 1;
        tween.stop();
      }, 2000);
    }
  }

  // Add Health for Doggo for 5 seconds
  addLives(amount){
    this.health++;
  }

  indiPower(power,bgmusic) {
    // Set dog Super Power
    switch(this.game.dogType){
      case "dog-yellow":
        this.dog1Super(bgmusic);
      break;
      case "doggo":
        this.dog2Super(bgmusic);
      break;
      case "dog-orange":
        this.dog3Super(bgmusic);
      break;
    }
  }
  dog1Super(music){
    let powerBar = this.children[1];
    this.scale.setTo(0.7, 0.7);
    this.breakPow = true;
    this.dogHitMusic.restart();
    this.dogHitMusic.play();
    this.dogHitMusic.fadeOut(10000);

    // powerBar.alpha = 1;
    const tweenpower = this.game.add.tween(powerBar).to( { width: 0 }, 10000)
    tweenpower.start();

    if (this.powerTimer === null) {
      this.powerTimer = setTimeout(() => {
        this.power = false;
        this.powerTimer = null;
        this.breakPow = false;
        this.game.damage = 1;
        this.scale.setTo(0.4, 0.4);
        powerBar.width = this.width;
        music.resume();
        this.dogHitMusic.stop();
      },10000);
    }
  }
  dog2Super(music){
    let powerBar = this.children[1];
    let oriX = {bodyX:this.x,camX:this.game.camera.x};
    this.body.allowGravity = false;
    this.body.velocity.y = 0;
    this._removeKey();
    this.dogFlySound.restart();
    this.dogFlySound.play();
    this.dogFlySound.fadeOut(8000);
    this.game.input.onDown.add(this.powerDown, this);

    this.loadTexture('dog-red-fly', 0);
    this.animations.add('dog-red-fly');
    this.animations.play('dog-red-fly', 60, true);

    // powerBar.alpha = 1;
    const tweenpower = this.game.add.tween(powerBar).to( { width: 0 }, 8000)
    tweenpower.start();
    
    if (this.powerTimer === null) {
      this.power = true;

      // Reset after 8 seconds
      this.powerTimer = setTimeout(() => {
        this.power = false;
        this.powerTimer = null;
        this.game.input.onDown.remove(this.powerDown,this);
        this.body.allowGravity = true;
        this.isJumping = true;
        this.body.velocity.x = 0;
        this.runningAnimation.speed = 120;
        this.jump.play();
        jumpCount += 1;
        this._attachEventListeners();
        this.loadTexture(this.game.dogType, 0);
        this.animations.add('run');
        this.runningAnimation = this.animations.play('run', 60, true);

        const tween = this.game.add.tween(this).to( { x: oriX.bodyX }, 1000, "Quart.easeOut")
        tween.start();
        powerBar.width = this.width;
        this.dogFlySound.stop();
        music.resume();
      }, 8000);
    }
  }
  dog3Super(music){
    let powerBar = this.children[1];
    this.power = true;
    this.breakPow = true;
    this.runningAnimation.speed = 180;
    this.game.obsPoint = 0;
    this.dogSpeedSound.restart()
    this.dogSpeedSound.play();
    this.dogSpeedSound.fadeOut(5000);

    this.loadTexture('dog-orange-run', 0);
    this.body.height = this.height;
    this.animations.add('dog-orange-run');
    this.animations.play('dog-orange-run', 180, true);
    
    // powerBar.alpha = 1;
    const tween = this.game.add.tween(this).to({ tint: 0xffe980 }, 100, Phaser.Easing.Linear.None, true, 0, -1, true);
    const tweenpower = this.game.add.tween(powerBar).to( { width: 0 }, 5000)
    tweenpower.start();

    if (this.powerTimer === null) {
      this.powerTimer = setTimeout(() => {
        this.breakPow = false;
        this.power = false;
        this.powerTimer = null;
        this.game.damage = 1;
        this.game.gameSpeedUp = 0;
        this.game.obsPoint = -10;
        this.runningAnimation.speed = 60;
        this.isJumping = false;
        this.hasDoubleJumped = false;

        tween.stop();

        this.loadTexture(this.game.dogType, 0);
        this.body.height = this.height;
        this.animations.add('run');
        this.runningAnimation = this.animations.play('run', 60, true);

        powerBar.width = this.width;
        this.dogSpeedSound.stop();
        music.resume();
      },5000);
    }
  }
  
  powerDown(e){
    this.game.physics.arcade.moveToPointer(this, 350);
  }

  _removeKey(){
    this.spaceKey.onDown.remove(this.keyDown, this);
    this.game.input.keyboard.removeKey(Phaser.Keyboard.SPACEBAR);
    this.game.input.onDown.remove(this.keyDown, this);
  }
}

export default Doggo;


// Analytics
window.addEventListener('beforeunload', (event) => {
  if (jumpCount > 0) {
    gtag('event', 'jump_metric', { 'jump_count': jumpCount });
  }

  if (doubleJumpCount > 0) {
    gtag('event', 'double_jump_metric', { 'double_jump_count': doubleJumpCount });
  }

  return null;
}, false);



// WEBPACK FOOTER //
// ./js/prefabs/doggo.js